// About page data with image requires
export function getAboutData() {
  return {
    intro: {
      heading: "About Us",
      paragraphs: [
        "Founded by Mr. V. Vinod Rau in 2009, Studio V began as a dedicated Taekwondo centre, focusing on discipline, skill, and personal growth. Over the years, we have expanded our offerings to include Kickboxing, Muay Thai, and Zumba exclusively for ladies, creating a versatile space for martial arts, fitness, and dance. With over 1,000 students trained, many of whom are now excelling all over the world, Studio V has built a reputation for excellence and dedication. Our team of 15 certified instructors brings passion, expertise, and personalized guidance to every class, ensuring members of all skill levels can achieve their goals.",
        "Whether you aim to master martial arts, boost your fitness, or enjoy energizing dance sessions, Studio V provides a safe, supportive, and motivating environment. We believe that fitness is a lifestyle, discipline is empowerment, and every step you take brings you closer to your best self.Join our global community and experience the energy, dedication, and results that have made Studio V a trusted name in health, fitness, and martial arts for over a decade.",
      ]
    },
    founders: [
      {
        id: "founder",
        role: "Founder",
        image: require("../assets/about_us/founder.jpg")
      },
      {
        id: "co-founder",
        role: "Co-Founder",
        image: require("../assets/about_us/co-founder.jpg")
      }
    ],
    achievements: {
      heading: "Our Achievement",
      items: [
        {
          id: "foundation",
          year: "Since 2009",
          title: "Foundation Journey",
          description: "We began as a dedicated Taekwondo training centre with a strong vision to build discipline, confidence, and character in every student. What started small quickly grew through passion, commitment, and community trust.",
          icon: require("../assets/about_us/sept2012.svg"),
          cardPosition: "left",
          datePosition: "right"
        },
        {
          id: "present",
          year: "2014",
          title: "Expansion Phase",
          description: "With increasing support, we expanded beyond Taekwondo to include Kickboxing and Muay Thai, introducing more dynamic combat training programs led by certified instructors.",
          icon: require("../assets/about_us/aug2012.svg"),
          cardPosition: "right",
          datePosition: "right"
        },
        {
          id: "growth",
          year: "2016-Present",
          title: "Growth & Community Impact",
          description: "Studio V evolved into a complete fitness hub, launching ladies-only Zumba classes and high-impact fitness programs.\nWe proudly trained 1000+ students, many of whom are now across the globe.",
          icon: require("../assets/about_us/jan2018.svg"),
          cardPosition: "left",
          datePosition: "right"
        }
      ]
    },
    team: {
      heading: "The Team",
      members: [
        {
          id: "vinod-rau-1",
          name: "MR V.Vinod Rau",
          role: "Founder / Chief Instructor",
          class: "Kickboxing & Muay Thai",
          image: require("../assets/about_us/vinodSirKB.png")
        },
        {
          id: "vinod-rau-2",
          name: "MR V.Vinod Rau",
          role: "Founder / Chief Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/vinodSirTKD.png")
        },
        {
          id: "alicia-tkd",
          name: "Coach Alicia Jane Jonathan",
          role: "Senior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/aliciaJaneJonathan.png")
        },
        {
          id: "fooAiLing-tkd",
          name: "Coach Foo Ai Ling",
          role: "Senior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/fooAiLing.png")
        },
        {
          id: "sharsmetha-tkd",
          name: "Coach Sharsmetha",
          role: "Senior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/sharsmetha.png")
        },
        {
          id: "hazeeq-tkd",
          name: "Coach Hazeeq",
          role: "Junior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/hazeeq.png")
        },
        {
          id: "kongZeHong-tkd",
          name: "Coach Kong Ze Hong",
          role: "Junior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/kongZeHong.png")
        },
        {
          id: "leslieJaneJonathan-tkd",
          name: "Coach Leslie Jane Jonathan",
          role: "Junior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/leslieJaneJonathan.png")
        },
        {
          id: "tanShengTong-tkd",
          name: "Coach Tan Sheng Tong",
          role: "Junior Instructor",
          class: "Taekwon-Do",
          image: require("../assets/about_us/tanShengTong.png")
        }
      ]
    }
  };
}

